import type {
  BreadcrumbItemSlots as BreadcrumbItemBaseSlots,
  BreadcrumbItemBaseProps,
  BreadcrumbItemBaseState,
} from '@fluentui/react-breadcrumb';

/**
 * BreadcrumbItem component slots
 */
export type BreadcrumbItemSlots = BreadcrumbItemBaseSlots;

/**
 * BreadcrumbItem component props
 */
export type BreadcrumbItemProps = BreadcrumbItemBaseProps;

/**
 * BreadcrumbItem component state
 */
export type BreadcrumbItemState = BreadcrumbItemBaseState;
